import { apiClient } from "./client";

export interface HourScenario {
  power_kw: number;
  volumes_kwh: Record<string, number>;
  cost_uah: number;
  cost_uah_per_mwh: number;
  revenue_uah: number;
  profit_uah: number;
  ekosfera_deficit_kwh: number;
}

export interface HourOptimum {
  hour: number;
  rdn_price_uah_per_mwh: number | null;
  rdn_price_is_forecast: boolean;
  plan_ekosfera_kwh: number | null;
  best: HourScenario;
}

export interface DayOptimum {
  date: string;
  hours: HourOptimum[];
  total_optimal_profit_uah: number;
  rdn_is_forecast: boolean;
}

export interface HourDetail {
  hour: number;
  rdn_price_uah_per_mwh: number | null;
  rdn_price_is_forecast: boolean;
  plan_ekosfera_kwh: number | null;
  scenarios: HourScenario[];
  best_index: number;
}

export interface RetroIntraday {
  date: string;
  hours: HourOptimum[];
  submitted_plan_profit_uah: number | null;
  optimal_profit_uah: number;
  lost_potential_uah: number | null;
}

export interface QuickCalcRequest {
  date: string;
  hour: number;
  power_kw: number;
  volumes: Record<string, number>;
  count_self_needs: boolean;
}

export interface QuickCalcOut {
  power_kw: number;
  energy: {
    self_needs_kwh: number;
    free_kwh: number;
    used_kwh: number;
    leftover_kwh: number;
  };
  rdn_price_uah_per_mwh: number | null;
  rdn_price_is_forecast: boolean;
  eko_tariff_uah_per_kwh: number | null;
  trader_fee_pct: number | null;
  revenue: {
    by_client: Record<string, number>;
    total_uah: number;
  };
  cost: {
    total_uah: number;
    cost_uah_per_mwh: number;
    gas_m3h: number;
  };
  profit_uah: number;
  warnings: string[];
}

export const optimizerApi = {
  day: (date: string) =>
    apiClient.get<DayOptimum>(`/optimizer/${date}`).then((r) => r.data),

  hour: (date: string, hour: number) =>
    apiClient
      .get<HourDetail>(`/optimizer/${date}/hour/${hour}`)
      .then((r) => r.data),

  retroIntraday: (date: string) =>
    apiClient
      .get<RetroIntraday>(`/optimizer/retro-intraday/${date}`)
      .then((r) => r.data),

  quickCalc: (req: QuickCalcRequest) =>
    apiClient
      .post<QuickCalcOut>("/optimizer/quick-calc", req)
      .then((r) => r.data),
};
